<template>
    <div class="addresscard-container">
        <div class="addresscard-row" xs12>
            <div class="addresscard-main-container">
                <div class="addresscard-title">{{ address.name === null ? '-' : address.name }}</div>
                <div class="addresscard-details">
                    <div class="addresscard-street">{{ address.street }}</div>
                    <div class="addresscard-street">{{ address.street1 }}</div>
                    <div class="addresscard-street">{{ address.city }} {{ address.postCode }}, {{ ((address.countryName === 'Mexico' || address.countryName === 'Canada' || address.countryName === 'United States') && address.region !== "" && address.region !== null) ? `${address.region}, ${address.countryName}` : address.countryName}}
                    </div>
                    <div class="addresscard-street" v-if="address.vat !== null && address.vat !== ''">VAT {{ address.vat}}
                    </div>
                </div>
                <div class="edit_container" v-on:click="openEditAddressPopup">
                    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                        <path d="M0 0h24v24H0z" fill="none"/>
                        <path
                            d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
                    </svg>
                    <div>{{ $t('edit') }}</div>
                </div>
            </div>

            <v-dialog v-model="editDialog" content-class="edit-address-dialog">
                <v-card class="edit-address-card">
                    <div class="addresscard-edit-container">
                        <v-container>
                            <div style="padding: 10px" v-if="!editAddressSuccess.visible && !editAddressFail.visible">
                                <v-row>
                                    <v-col>
                                        <h4>Edit Address</h4>
                                        <div class="add-new-address-close" @click="closeEditAddressPopup">
                                            &times;
                                            <div>{{ $t('sell8') }}</div>
                                        </div>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <span class="myprofile-label">{{ $t('address6') }} *</span>
                                        <v-text-field v-model="newAddress.name" :rules="[rules.required]"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <h5>{{ $t('personal-info') }}</h5>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <span class="myprofile-label">{{ $t('myprofile1') }} *</span>
                                        <v-text-field v-model="newAddress.firstName" :rules="[rules.required]"></v-text-field>
                                    </v-col>
                                    <v-col>
                                        <span class="myprofile-label">{{ $t('myprofile2') }} *</span>
                                        <v-text-field v-model="newAddress.lastName" :rules="[rules.required]"></v-text-field>
                                    </v-col>
                                    <v-col>
                                        <span class="myprofile-label">{{ $t('myprofile4') }} *</span>
                                        <v-text-field v-model="newAddress.phoneNumber" :rules="[rules.required]"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <h5>{{ $t('company-info') }}</h5>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <span class="myprofile-label">{{ $t('company-name') }}</span>
                                        <v-text-field v-model="newAddress.company"></v-text-field>
                                    </v-col>
                                    <v-col>
                                        <span class="myprofile-label">{{ $t('invoice05') }}</span>
                                        <v-text-field v-model.trim="newAddress.vat" :rules="[rules.min]"></v-text-field>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col>
                                        <h5>{{ $t('address10') }}</h5>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <span class="myprofile-label">{{ $t('address11') }} *</span>
                                        <v-text-field v-model="newAddress.street" :rules="[rules.required]"></v-text-field>
                                    </v-col>
                                    <v-col>
                                        <span class="myprofile-label">{{ $t('address12') }}</span>
                                        <v-text-field v-model="newAddress.street1"></v-text-field>
                                    </v-col>
                                    <v-col>
                                        <span class="myprofile-label">{{ $t('address13') }} *</span>
                                        <v-text-field v-model="newAddress.postCode" :rules="[rules.required]" placeholder=" "></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row class="last-row">
                                    <v-col>
                                        <span class="myprofile-label">{{ $t('address14') }} *</span>
                                        <v-text-field v-model="newAddress.city"
                                                      :rules="[rules.required]"></v-text-field>
                                    </v-col>
                                    <v-col v-if="vin_countries.length" class="country-container">
                                        <span class="myprofile-label">{{ $t('address15') }} *</span>
                                        <country-select class="country-select" :class="countryError ? 'error-msg' : ''"
                                                        :whiteList="vin_countries" :rules="[rules.required]"
                                                        v-model="country" :country="country"/>
                                        <div v-if="countryError" class="v-text-field__details">
                                            <div class="v-messages theme--light error--text">
                                                <div class="v-messages__wrapper">
                                                    <div class="v-messages__message">Required.</div>
                                                </div>
                                            </div>
                                        </div>
                                    </v-col>
                                    <v-col v-if="country === 'US' || country === 'MX' || country === 'CA'">
                                        <span class="myprofile-label">{{ $t('region') }} *</span>
                                        <v-text-field v-model="newAddress.region" :rules="[rules.required]"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-flex xs12 class="default-chkbox-wrapper">
                                    <v-checkbox :disabled="addressList === 1" v-model="isDefaultBilling" :label="$t('save-as-default-billing')"></v-checkbox>
                                </v-flex>
                                <v-flex xs12 class="default-chkbox-wrapper">
                                    <v-checkbox :disabled="addressList === 1" v-model="isDefaultShipping" :label="$t('save-as-default-delivery')"></v-checkbox>
                                </v-flex>
                            </div>
                            <v-layout wrap v-if="editAddressFail.visible" class="addaddress-result-container">
                                <div class="result-error"></div>
                                <span class="addaddress-fail-text">{{editAddressFail.text}}</span>
                            </v-layout>
                            <v-layout wrap v-if="editAddressSuccess.visible" class="addaddress-result-container">
                                <div class="result-success"></div>
                                <span class="addaddress-success-text">{{editAddressSuccess.text}}</span>
                            </v-layout>

                            <div class="addresscard-button-wrapper">
                                <v-btn class="addresscard-edit-saveBtn" v-on:click="editAddress" :disabled="!valid"
                                       v-if="!editAddressFail.visible && !editAddressSuccess.visible">{{ $t('save') }}
                                </v-btn>
                                <v-btn class="addresscard-edit-cancelBtn" v-on:click="closeEditAddressPopup">{{
                                    $t('cancel') }}
                                </v-btn>
                                <div class="reset-btn" v-on:click="deleteDialog = true">Delete
                                    <div class="link-border"></div>
                                </div>
                            </div>
                        </v-container>
                    </div>
                </v-card>
            </v-dialog>
        </div>

        <v-dialog v-model="deleteDialog" max-width="570px">
            <v-card class="reset-changes-modal">
                <div class="warning-icon"></div>
                <v-card-title>Delete address</v-card-title>

                <v-card-text class="reset-changes-body">
                    Are you sure you want delete this address?
                </v-card-text>

                <v-card-actions>
                    <v-btn class="btn-primary btn-reset-proceed" text v-on:click="deleteDialog = false">Close</v-btn>
                    <v-btn class="btn-secondary btn-reset-cancel" text v-on:click="deleteAddress">Delete</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="confirmAddressModal" max-width="500px" persistent>
            <v-card class="bids-offers-modal confirm-address-modal">
                <v-card-title>{{ $t('confirm-address01') }}</v-card-title>
                <v-card-text class="cancel-bid-body">
                    {{ $t('confirm-address02') }}
                </v-card-text>
                <v-card-actions>
                    <v-btn class="btn-primary btn-bid-close" text v-on:click="() => { confirmAddressModal = false }">{{ $t('confirm-address03') }}</v-btn>
                    <v-btn class="btn-primary btn-bid-proceed" text v-on:click="confirmAddress">{{ $t('confirm-address04') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="confirmAddressModal2" max-width="500px" persistent>
            <v-card class="bids-offers-modal confirm-address-modal">
                <v-card-title>{{ $t('confirm-address01') }}</v-card-title>
                <v-card-text class="cancel-bid-body">
                    {{ $t('confirm-address02') }}
                </v-card-text>
                <v-card-actions>
                    <v-btn class="btn-primary btn-bid-close" text v-on:click="() => { confirmAddressModal2 = false }">{{ $t('confirm-address03') }}</v-btn>
                    <v-btn class="btn-primary btn-bid-proceed" text v-on:click="confirmAddress2">{{ $t('confirm-address04') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <div class="both-types">
            <v-checkbox v-model="isDefaultBilling" :label="$t('address3')" :disabled="!changeDefaultBilling"
                        v-on:click="updateDefaultAddress(true)"></v-checkbox>
            <v-checkbox v-model="isDefaultShipping" :label="$t('address4')" :disabled="!changeDefaultShipping"
                        v-on:click="updateDefaultAddress(false)"></v-checkbox>
        </div>
    </div>
</template>

<script>
import {ACommon, AUser} from '@/store/actions';
import {mapGetters, mapState} from "vuex";
import {MUser} from "@/store/mutations";
import {required, minLength} from 'vuelidate/lib/validators';
import {GUser} from "~/store/getters";

export default {
    name: "Addresscard",
    props: ['address', 'addressList'],
    validations: {
        newAddress: {
            name: {
                required
            },
            firstName: {
                required
            },
            lastName: {
                required
            },
            phoneNumber: {
                required
            },
            street: {
                required
            },
            postCode: {
                required
            },
            city: {
                required
            },
            vat: {
                minLength: minLength(10)
            }
        },
        country: {
            required
        }
    },
    data() {
        return {
            valid: true,
            deleteDialog: false,
            confirmAddressModal: false,
            confirmAddressModal2: false,
            editDialog: false,
            editAddressSuccess: {
                visible: false,
                text: 'Address added successfully!'
            },
            editAddressFail: {
                visible: false,
                text: 'Please review again all the information and try again!'
            },
            isDefaultBilling: this.addressList === 1,
            isDefaultShipping: this.addressList === 1,
            newAddress: {
                name: "",
                type: 3,
                street: "",
                street1: "",
                city: "",
                postCode: "",
                countryId: 4,
                country: "",
                region: "",
                vat: "",
                note: "",
                company: "",
                phoneNumber: "",
                firstName: "",
                lastName: ""
            },
            changeDefaultBilling: true,
            changeDefaultShipping: true,
            country: null,
            rules: {
                required: value => !!value || 'Required.',
                min: value => !value.length ? true : value.trim().length >= 10 || 'Min 10 characters'
            },
            countryError: false,
            vin_countries: [],
            countryMap: []
        }
    },
    computed: {
        ...mapState({
            countries: state => state.countries
        }),
        ...mapGetters({
           statusKYC: GUser.GET_KYC_STATUS
       })
    },
    methods: {
        deleteAddress() {
            this.$store.dispatch(AUser.DELETE_ADDRESS, this.address).then(() => {
                this.$store.commit(MUser.SET_ADDRESSES, []);
                this.$store.dispatch(AUser.GET_ADDRESSES);
            });
        },
        updateDefaultAddress(updateBilling) {
            if (updateBilling) {
                if (this.isDefaultShipping) {
                    this.newAddress.type = 3;
                } else {
                    this.newAddress.type = 1;
                }
            } else {
                if (this.isDefaultBilling) {
                    this.newAddress.type = 3;
                } else {
                    this.newAddress.type = 2;
                }
            }

            if (this.statusKYC === 1) {
                this.confirmAddressModal2 = true
            } else {
                this.confirmAddress2()
            }
        },
        confirmAddress2() {
            this.$store.dispatch(AUser.UPDATE_ADDRESS, this.newAddress).then(() => {
                this.$store.commit(MUser.SET_ADDRESSES, []);
                this.$store.dispatch(AUser.GET_ADDRESSES);
            }).catch(() =>
                this.editAddressFail.visible = true
            )
        },
        editAddress() {
            if (this.newAddress.name && this.newAddress.firstName && this.newAddress.lastName && this.newAddress.phoneNumber &&
                this.newAddress.street && this.newAddress.postCode && this.newAddress.city) {

                if (!this.country) {
                    this.countryError = true;
                    return;
                }

                this.countryError = false;

                if (this.newAddress.vat !== '' && (this.newAddress.vat.trim().length < 10 || this.$v.newAddress.vat.$invalid)) {
                    return
                }

                if (this.isDefaultBilling && this.isDefaultShipping) {
                    this.newAddress.type = 3;
                } else if (!this.isDefaultBilling && !this.isDefaultShipping) {
                    this.newAddress.type = 4;
                } else if (this.isDefaultBilling && !this.isDefaultShipping) {
                    this.newAddress.type = 1;
                } else {
                    this.newAddress.type = 2;
                }
                this.newAddress.countryId = this.countries[this.country].id;
                this.newAddress.country = this.countries[this.country].value;
                this.newAddress.countryName = this.countries[this.country].value;

                if (this.statusKYC === 1) {
                    this.confirmAddressModal = true
                } else {
                    this.confirmAddress()
                }
            }
        },
        confirmAddress() {
            this.$store.dispatch(AUser.UPDATE_ADDRESS, this.newAddress).then(() => {
                this.$store.commit(MUser.SET_ADDRESSES, []);
                this.closeEditAddressPopup();
                this.$store.dispatch(AUser.GET_ADDRESSES);
            }).catch(() =>
                this.editAddressFail.visible = true
            )
        },
        openEditAddressPopup() {
            this.editDialog = true;
            let editAddressCtrl = this;
            for (let key in this.countries) {
                if (this.countries.hasOwnProperty(key)) {
                    if (this.countries[key].id === this.newAddress.countryId.toString()) {
                        editAddressCtrl.country = key;
                        break;
                    }
                }
            }
        },
        closeEditAddressPopup() {
            this.editDialog = false;

            if (window) {
                document.getElementsByClassName('edit-address-dialog')[0].scrollTop = 0;
            }

            this.editAddressSuccess.visible = false;
            this.editAddressFail.visible = false;
        },
        getCountries() {
            this.vin_countries = Object.keys(this.countries);
            this.vin_countries.forEach((code) => {
                let allCountries = this.countries,
                    newCountry = {};
                newCountry.id = parseInt(allCountries[code].id);
                newCountry.code = code;
                newCountry.value = allCountries[code].value;
                this.countryMap.push(newCountry);
            })
        }
    },
    created() {
        this.$store.dispatch(ACommon.GET_ALL_COUNTRIES);
        this.$store.dispatch(AUser.GET_KYC_STATUS);
        this.newAddress = Object.assign({}, this.address);
        this.getCountries();

        if (this.newAddress.type === 3) {
            this.isDefaultBilling = true;
            this.isDefaultShipping = true;
            this.changeDefaultBilling = false;
            this.changeDefaultShipping = false;
        } else if (this.newAddress.type === 4) {
            this.isDefaultBilling = false;
            this.isDefaultShipping = false;
            this.changeDefaultBilling = true;
            this.changeDefaultShipping = true;
        } else if (this.newAddress.type === 1) {
            this.isDefaultBilling = true;
            this.isDefaultShipping = false;
            this.changeDefaultBilling = false;
            this.changeDefaultShipping = true;
        } else {
            this.isDefaultBilling = false;
            this.isDefaultShipping = true;
            this.changeDefaultBilling = true;
            this.changeDefaultShipping = false;
        }
    }
}
</script>

<style scoped>
.bids-offers-modal {
    padding: 32px 48px;
    text-align: center;
    background: #f6f6f6;
}
    .myprofile-label {
        font-size: var(--fs-base);
        color: #303030;
        font-weight: 300;
        position: absolute;
        margin-top: -14px;
    }

    .both-types {
        position: absolute;
        margin-top: 16px;
    }

    .addresscard-container {
        font-family: 'Roboto', sans-serif;
        font-weight: 400;
        margin-bottom: 80px;
        background-color: #ffffff;
        border: 0;
    }

    .darkmode .addresscard-container {
        background-color: #363945;
    }

    .addresscard-details {
        color: #484948;
        font-size: 16px;
    }

    .darkmode .addresscard-details {
        color: #ffffff;
    }

    .darkmode .addresscard-details span.vat-label {
        color: #93949B;
    }

    .addresscard-button-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .addresscard-button-wrapper button {
        flex: 1;
        min-width: 100% !important;
        width: 100% !important;
        height: 46px !important;
        padding: 10px 16px !important;
        margin: 0 !important;
    }

    .addresscard-button-wrapper button + button {
        margin-top: 10px !important;
    }

    .addresscard-button-wrapper .reset-btn {
        flex: 1;
        margin: 10px 0 !important;
        width: 100% !important;
    }

    .addaddress-result-container {
        max-width: 350px;
        margin: 0 auto !important;
    }
    .result-success {
        background: url('../assets/successful.gif') no-repeat center;
        background-size: contain;
        width: 300px;
        height: 250px;
        margin: 0 auto;
    }
    .result-error {
        background: url('../assets/unsuccessful.gif') no-repeat center;
        background-size: contain;
        width: 300px;
        height: 250px;
        margin: 0 auto;
    }

    .addaddress-fail-text {
        color: red;
        font-size: 1em;
        text-align: center;
        width: 100%;
    }

    .addaddress-success-text {
        font-size: 1em;
        text-align: center;
        width: 100%;
    }

    .addresscard-row {
        padding: 25px 40px;
        position: relative;
    }

    .addresscard-title {
        font-weight: 500;
        color: #5F605F;
        font-size: 21px;
        margin-bottom: 30px;
    }

    .darkmode .addresscard-title {
        color: #E5C57B;
    }

    .edit_container {
        position: absolute;
        top: 0;
        right: -18px;
        color: #303030;
        font-size: 16px;
        line-height: 16px;
    }
    .edit_container svg {
        margin-left: 2px;
    }

    .edit_container:hover {
        cursor: pointer;
        color: var(--blue);
    }

    .edit_container:hover svg {
        fill: var(--blue);
    }

    .addresscard-main-container {
        position: relative;
    }
    .addresscard-edit-saveBtn {
        height: 60px !important;
        color: #FFFFFF;
        background-color: #024E7B !important;
        border-color: #024E7B !important;
        text-transform: capitalize;
        font-size: 18px;
    }
    .both-types {
        display: inline-block;
        vertical-align: top;
    }
    .both-types > div:nth-child(2) {
        margin: 0 15px;
    }
    .add-new-address-close {
        position: absolute;
        right: 15px;
        top: 10px;
        text-transform: uppercase;
        font-family: Arial, sans-serif;
        font-size: 24px;
        color: #B0B1B0;
        text-align: right;
        padding-right: 4px;
        font-weight: 300;
    }
    .add-new-address-close div {
        font-size: 16px;
        font-family: Roboto, sans-serif;
        text-transform: initial;
        position: relative;
        right: -4px;
    }
    .add-new-address-close:hover {
        cursor: pointer;
        color: var(--brand);
    }
    .country-select {
        webkit-box-flex: 1;
        -ms-flex: 1 1 auto;
        flex: 1 1 auto;
        line-height: 32px;
        padding: 0;
        max-width: 100%;
        min-width: 0;
        width: 100%;
        border-bottom: 1px solid #b2b2b2;
        margin: 0;
        height: 50px;
        margin-top: 16px;
        padding-left: 15px;
        font-size: 19px;
        font-weight: 400;
        color: #333333;
        background-color: #fff;
    }
    .country-select:hover {
        border-color: var(--brand);
        cursor: pointer;
    }
    .country-select:focus,
    .country-select:active {
        border-bottom: 2px solid #000000;
    }

    @media(max-width: 767px) {
        .addresscard-container {
            margin-bottom: 32px;
        }
        .both-types {
            position: relative;
            padding: 0 25px;
        }
        .both-types > div:nth-child(2) {
            margin: 0;
        }
    }
</style>

<style>
    .addresscard-edit-container .col {
        position: relative;
    }

    .both-types .v-input {
        display: inline-block;
    }

    @media(max-width: 767px) {
        .both-types .v-input {
            display: block;
        }
    }

    .delete_icon span.v-btn__content {
        font-size: 15px;
        color: #000000;
        font-weight: 400;
    }

    .addresscard-edit-cancelBtn span {
        font-size: 17px;
        color: #024E7B;
        font-family: 'Roboto', sans-serif;
        font-weight: 400;
        letter-spacing: 0;
    }

    .default-chkbox-wrapper .accent--text {
        color: #024e7b !important;
        caret-color: #024e7b !important;
    }

    .addresscard-street {
        margin-bottom: 10px;
    }

    .v-dialog.edit-address-dialog {
        max-width: 1024px;
        border-radius: 15px;
    }

    .v-dialog.edit-address-dialog h1 {
        color: #6F706F;
        position: relative;
        margin-bottom: 30px;
    }

    .v-dialog.edit-address-dialog h5 {
        margin-bottom: 20px;
    }

    .v-dialog.edit-address-dialog .v-input input {
        height: 50px;
        max-height: unset;
        margin-top: 0;
        padding-left: 15px;
        font-size: 20px;
        font-weight: 400;
        color: #333333;
    }

    .v-dialog.edit-address-dialog .v-input .v-label {
        font-size: 19px;
        font-weight: 300;
        color: #707070;
    }

    .v-dialog.edit-address-dialog .country-container .v-label {
        -webkit-transform: translateY(-18px) scale(.75);
        transform: translateY(-18px) scale(.75);
        height: 20px;
        line-height: 20px;
        top: -10px;
        position: relative;
    }

    .v-dialog.edit-address-dialog .theme--light.v-card {
        padding: 10px;
        background: #F5F6F5;
    }

    .v-dialog.edit-address-dialog .theme--light.v-card .row {
        flex-direction: column;
    }

    .v-dialog.edit-address-dialog .theme--light.v-card .v-card__text {
        padding: 0;
    }

    .v-dialog.edit-address-dialog .theme--light.v-card .v-card__text .row > .col {
        padding-top: 5px;
        padding-bottom: 5px;
    }

    .v-dialog.edit-address-dialog .last-row {
        margin-top: 20px;
    }

    .v-dialog.edit-address-dialog .addresscard-edit-saveBtn {
        background: #E1C376 !important;
        color: #FFF !important;
        width: 200px;
        height: 45px !important;
        font-size: 18px;
        border-radius: 5px;
        text-transform: none;
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        letter-spacing: 0;
        font-weight: lighter;
        -webkit-box-shadow: none;
        box-shadow: none;
        margin: 32px 0 0;
    }

    .v-dialog.edit-address-dialog .addresscard-edit-cancelBtn {
        background: transparent !important;
        color: #686968 !important;
        height: 45px !important;
        font-size: 18px;
        border-radius: 5px;
        text-transform: none;
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        letter-spacing: 0;
        border: 1px solid #B1B2B1;
        font-weight: lighter;
        -webkit-box-shadow: none;
        box-shadow: none;
        margin: 32px 0 0 32px;
    }

    .v-dialog.edit-address-dialog .addresscard-edit-cancelBtn span {
        color: #686968;
    }

    .v-dialog.edit-address-dialog .v-card__actions {
        margin-top: 10px;
    }

    .v-dialog.edit-address-dialog .theme--light.v-input:not(.v-input--is-disabled) textarea {
        background: #fff;
    }

    .v-dialog.edit-address-dialog .default-chkbox-wrapper .accent--text label {
        top: 0;
    }

    .default-chkbox-wrapper .v-input--checkbox .theme--light.v-messages {
        display: none;
    }

    .default-chkbox-wrapper .v-input--selection-controls {
        margin-top: 0;
    }

    .edit-address-close {
        position: absolute;
        right: 15px;
        top: 5px;
        text-transform: uppercase;
        font-family: Arial, sans-serif;
        font-size: 16px;
        color: #B0B1B0;
    }

    .add-new-address-label {
        position: absolute;
        right: 10px;
        top: 25px;
        font-family: Arial, sans-serif;
        font-size: 13px;
        font-weight: normal;
    }

    .edit-address-close:hover {
        cursor: pointer;
    }

    .darkmode .edit-address-close {
        color: #9B9DA5;
    }

    .darkmode .edit-address-close:hover {
        color: #ffffff;
    }

    .v-dialog.edit-address-dialog .country-container .v-label {
        -webkit-transform: translateY(-18px) scale(.75);
        transform: translateY(-18px) scale(.75);
        height: 20px;
        line-height: 20px;
        top: -10px;
        position: relative;
    }

    .v-dialog.edit-address-dialog .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
        border: 0;
    }

    .v-dialog.edit-address-dialog .v-input input:hover {
        border-color: var(--brand);
    }

    .reset-btn {
        color: rgba(0, 0, 0, .64);
        width: 50px;
        display: inline-block;
        font-size: 19px;
        text-align: center;
        margin-top: 38px;
        margin-left: 32px;
        height: 23px;
        vertical-align: top;
    }

    .reset-btn .link-border {
        height: 1px;
        width: 100%;
        background: #707070;
    }

    .reset-btn:hover {
        color: var(--blue);
        cursor: pointer;
    }

    .reset-btn:hover .link-border {
        background: var(--blue);
    }

    .reset-changes-modal {
        padding: 32px 48px;
        text-align: center;
    }

    .reset-changes-modal .warning-icon {
        background: url('../assets/report_problem-24px.svg') no-repeat center;
        background-size: contain;
        width: 40px;
        height: 40px;
        margin: 0 auto;
    }

    .reset-changes-body {
        text-align: center;
        justify-content: center;
        font-size: var(--fs-base);
    }

    .success-alert {
        background: #D4ECC9;
        border: 1px solid #A9DC8F;
        padding: 5px;
        text-align: center;
        color: #3B990D;
    }

    .fail-alert {
        background: #FF7F7F;
        border: 1px solid #FF0000;
        padding: 5px;
        text-align: center;
    }
    .v-dialog > .v-card.confirm-address-modal.bids-offers-modal > .v-card__title{
        color: rgba(0, 0, 0, 0.88);
        text-align: center;
        font-family: Montserrat, sans-serif;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        padding: 16px;
    }
    .v-dialog > .v-card.confirm-address-modal.bids-offers-modal > .v-card__actions {
        padding: 20px 16px 0;
        align-items: flex-start;
        gap: 16px;
        align-self: stretch;
    }
    .v-dialog > .v-card.confirm-address-modal.bids-offers-modal > .v-card__actions > .v-btn.btn-bid-close {
        flex: 1 0 0;
        border-radius: 8px;
        border: 2px solid #004F7F;
        background: transparent;
        display: flex;
        padding: 16px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 10px;
        align-self: stretch;
        margin-right: 0;
        height: 51px;
    }
    .v-dialog > .v-card.confirm-address-modal.bids-offers-modal > .v-card__actions > .v-btn.btn-bid-close .v-btn__content {
        color: #004F7F;
        text-align: center;
        font-family: Montserrat, sans-serif;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: uppercase;
    }
    .v-dialog > .v-card.confirm-address-modal.bids-offers-modal > .v-card__actions > .v-btn.btn-bid-proceed {
        border-radius: 8px;
        background: #004F7F;
        border: 2px solid #004F7F;
        display: flex;
        padding: 16px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 10px;
        align-self: stretch;
        flex: 1 0 0;
        margin-left: 0;
        height: 51px;
    }
    .v-dialog > .v-card.confirm-address-modal.bids-offers-modal > .v-card__actions > .v-btn.btn-bid-proceed .v-btn__content {
        color: #FFF;
        text-align: center;
        font-family: Montserrat, sans-serif;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: uppercase;
    }
</style>
